import PropTypes from 'prop-types'

export default PropTypes.shape({
  id: PropTypes.number,
  key: PropTypes.string,
  category: PropTypes.oneOf([
    'article',
    'case_study',
    'customer_testimonial',
    'download',
    'line_card',
    'podcast',
    'price_list',
    'video',
    'webinar',
    'white_paper'
  ]).isRequired,
  title: PropTypes.string,
  summary: PropTypes.string,
  imageUrl: PropTypes.string,
  bgImage: PropTypes.string,
  fullWidth: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark'])
})
